import { render, staticRenderFns } from "./IncidentsBarChart.vue?vue&type=template&id=12b92650&scoped=true"
import script from "./IncidentsBarChart.vue?vue&type=script&lang=js"
export * from "./IncidentsBarChart.vue?vue&type=script&lang=js"
import style0 from "./IncidentsBarChart.vue?vue&type=style&index=0&id=12b92650&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b92650",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
